var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4756 3.13068C13.913 2.91816 11.3567 1.90563 8.89408 0.118078C8.66904 -0.0444341 8.36279 -0.0381777 8.14404 0.130552C5.96898 1.78687 3.41263 2.7994 0.550022 3.13068C0.237511 3.16818 0 3.43068 0 3.74945V7.75582C0 13.1747 3.25637 17.9624 8.29404 19.9562C8.36904 19.9875 8.44404 20 8.5253 20C8.6003 20 8.68155 19.9875 8.75655 19.9562C13.7942 17.9624 17.0506 13.1747 17.0506 7.75582V3.74945C17.0506 3.42443 16.8006 3.15567 16.4756 3.13068ZM9.71911 10.4497L10.2191 12.281C10.3629 12.7872 9.98161 13.2873 9.45032 13.2873H7.59402C7.06899 13.2873 6.68773 12.7872 6.82526 12.281L7.33152 10.4497C7.3815 10.2684 7.32527 10.0747 7.194 9.93714C6.75648 9.51213 6.53148 8.86212 6.68148 8.17457C6.83148 7.48706 7.38775 6.91831 8.08152 6.76206C9.31283 6.48079 10.4129 7.41832 10.4129 8.59962C10.4129 9.12462 10.2003 9.59964 9.8566 9.93714C9.71911 10.0747 9.6691 10.2684 9.71911 10.4497Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyPolicy);
export default __webpack_public_path__ + "static/media/PrivacyPolicy.cc67680267018204d9247210c9217e4e.svg";
export { ForwardRef as ReactComponent };